import React, { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";

/**
 * ReclaimBar — T4 · always-visible kill switch during AI takeover.
 *
 * Polls sos_events every 4s looking for `escalated_to_ai=true` records.
 * When present, mounts a full-width red bar at the top of the Floor with
 * a single RECLAIM CONTROL action. Non-negotiable UX during any AI takeover.
 */
export default function ReclaimBar() {
  const [aiSos, setAiSos] = useState(null);
  useEffect(() => {
    let cancel = false;
    const pull = async () => {
      try {
        const { data } = await apiClient.get("/rider/admin/sos/active");
        if (cancel) return;
        const rows = Array.isArray(data?.items) ? data.items : [];
        const aiEscalated = rows.filter((r) => r.escalated_to_ai);
        setAiSos(aiEscalated[0] || null);
      } catch { /* silent */ }
    };
    pull();
    const t = setInterval(pull, 4000);
    return () => { cancel = true; clearInterval(t); };
  }, []);

  if (!aiSos) return null;
  const reclaim = async () => {
    try {
      await apiClient.post(`/floor/sos/${aiSos.id}/reclaim`);
      setAiSos(null);
    } catch (e) { /* toast handled elsewhere */ }
  };
  return (
    <div className="reclaim-bar" data-testid="reclaim-bar" role="alert">
      <div className="rb-label">
        <span className="rb-pulse" />
        <span>AI IS IN CONTROL · SOS {String(aiSos.id).slice(0, 8)}
          {(aiSos.driver_name || aiSos.rider_name) ? ` · ${aiSos.driver_name || aiSos.rider_name}` : ""}</span>
      </div>
      <button className="rb-btn" onClick={reclaim} data-testid="reclaim-btn">
        RECLAIM CONTROL
      </button>
    </div>
  );
}
